import { useEffect } from "react";
import UniBtn, { UniBtnPack } from "./UniBtn";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import { _zzyourmap_extract_editorjs_renderable_data } from "../utils/zz/zz-yourmap-blog-post-utils";
import { yourmapNavMaker, _zzyourmap_routing_browser_title_update, _zzyourmap_routing_routeState_to_path, _zzyourmap_routing_static_pages_keys, _zzyourmap_routing_tab_keys } from "../utils/zz/zz-yourmap-routing";
import { _zzyourmap_config } from "../utils/zz/zz-yourmap-config";
import UniPair from "./UniPair";
import UniLink from "./UniLink";
import { rapidozi_dummysmarty_utils } from "../utils/frfr-rapidozi-dummy-utils";


//
const YourmapCardDestinacija = (props) => {
  const {
    viarouterNavigate,
  } = props.appPack;
  const item = props.item;
  // const destination_item_id = item.of_id; // of_id destinacije
  const destination_item_id = item.destinacija_slug; // slug destinacije
  // const img_url_full = _zzyourmap_extract_destination_main_img_url(item);
  const img_url_full = item._main_img_url;
  const style = {
    backgroundImage: 'url("' + img_url_full + '")',
  };
  return (
    <>
      <div className="yourmap__card yourmap__card--destination uu-shadow-alien-fluent2-tile-shadow">
        <div className="yourmap__card__overlay-1" style={style}></div>
        <div className="yourmap__card__overlay-2"></div>
        <div className="yourmap__card-destinacija-content">
          <div className="yourmap__article__title-and-subtitle">
            <div className="uu-gap-standalone-1rem"></div>
            <h3>{item.destinacija_naslov}</h3>
            <p>{item.destinacija_podnaslov}</p>
          </div>
          <div>
            <div className="uu-vector uu-gaps-m-1rem">
              <UniBtn
                wide
                titleBeforeIcon
                title="Istraži"
                i="fa fa-arrow-right"
                extraClass="yourmap__theme__custom-btn-blue"
                handleClick={(e) => {
                  e.preventDefault();
                  // setRouteRoot('ROOT_DESTINATION_ITEM', destination_item_id);
                  viarouterNavigate(yourmapNavMaker.ROOT_DESTINATION_ITEM(destination_item_id));
                }}
                href={yourmapNavMaker.ROOT_DESTINATION_ITEM(destination_item_id)}
              />
              <UniBtn
                wide
                titleBeforeIcon
                title="Mapa"
                i="fa fa-map-o"
                extraClass="yourmap__theme__custom-btn-orange"
                handleClick={(e) => {
                  e.preventDefault();
                  // setRouteRoot('ROOT_MAP', destination_item_id);
                  viarouterNavigate(yourmapNavMaker.ROOT_MAP(destination_item_id));
                }}
                href={yourmapNavMaker.ROOT_MAP(destination_item_id)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


// DEFAULT COMPONENT
const YourmapSectionDestionationList = (props) => {
  const {
    destination_entities,
    destination_entities_fetching,
    route_root,
  } = props.appPack;
  if (route_root === 'ROOT_DESTINATION_LIST') {
    const title = 'Istraži sve destinacije';
    _zzyourmap_routing_browser_title_update(title);
  }
  let arr = destination_entities;
  if (props.limit > 0) { // CASE HOME PAGE
    // arr = pagination_utils.array_filter_only_items_in_page(props.limit, 1, destination_entities);
    arr = Easy69_v1.fix_always_arr(destination_entities, props.limit);
  }
  return (
    <>
      <section className="yourmap__section">
        <div className="inner">
          <div className="yourmap__grid yourmap__grid--gaps-1rem yourmap__grid--items-w-1-2">
            {
              // rapidozi_dummysmarty_utils.item_to_arr(null, 4).map((item, index) => {
              arr.map((item, index) => {
                return (
                  <div key={index} className="xi">
                    <YourmapCardDestinacija appPack={props.appPack} item={item} />
                  </div>
                );
              })
            }

            {
              false && (
                rapidozi_dummysmarty_utils.item_to_arr(null, 3).map((item, index) => {
                  return (
                    <div key={index} className="xi">
                      <div className="yourmap__card yourmap__card--destination uu-shadow-alien-fluent2-tile-shadow">
                        item
                      </div>
                    </div>
                  );
                })
              )
            }

          </div>
        </div>
      </section>
    </>
  );
};

export default YourmapSectionDestionationList;